﻿import $ from "jquery";
import "bootstrap";
import { GuiDetailAktion } from "./GuiDetailAktion";

export class GuiDetailBestellungAktion extends GuiDetailAktion {

    constructor() {
        super();
    }

    attachEvents() {
        super.attachEvents();
    }

    protected getUrlParameter(): string {
        const bestellungId = $("#BestellungId").val();
        return `bestellungId=${bestellungId}`;
    }
   
}
